
var createjs = typeof createjs !== 'undefined' ? createjs : {},
	AdobeAn = typeof AdobeAn !== 'undefined' ? AdobeAn : {};

$(window).on('createjs', function() {
	
		var cjs = createjs||{}, an = AdobeAn||{};
		var p; // shortcut to reference prototypes
		var lib={};var ss={};var img={};
		lib.ssMetadata = [];

		(lib.rotation = function(mode,startPosition,loop) {
			this.initialize(mode,startPosition,loop,{});
		
			// Layer_1
			this.shape = new cjs.Shape();
			this.shape.graphics.f().s("#FF7800").ss(4,1,1).p("Ag0gYQA4AAAoAoQAFAFAEAE");
			this.shape.setTransform(21.5,4.5);
		
			this.shape_1 = new cjs.Shape();
			this.shape_1.graphics.f().s("#FF7800").ss(4,1,1).p("Ag9gmQA5ABAnAnQARARAKAU");
			this.shape_1.setTransform(22.4,5.9);
		
			this.shape_2 = new cjs.Shape();
			this.shape_2.graphics.f().s("#FF7800").ss(4,1,1).p("AhDg4QA5ABAnAoQAfAeAIAq");
			this.shape_2.setTransform(23,7.7);
		
			this.shape_3 = new cjs.Shape();
			this.shape_3.graphics.f().s("#FF7800").ss(4,1,1).p("AhEhlQA4ABAoAoQApApAAA6QAAAXgGAUQgEAKgFAK");
			this.shape_3.setTransform(23.1,12.2);
		
			this.shape_4 = new cjs.Shape();
			this.shape_4.graphics.f().s("#FF7800").ss(4,1,1).p("Ag+iFQAxAFAjAkQApApAAA5QAAAXgGAVQgKAegZAZQgSASgVAL");
			this.shape_4.setTransform(23.7,15.4);
		
			this.shape_5 = new cjs.Shape();
			this.shape_5.graphics.f().s("#FF7800").ss(4,1,1).p("AgIiIQAdAKAYAYQApApAAA6QAAAWgGAVQgKAfgZAYQgpAqg5AAQgQAAgQgE");
			this.shape_5.setTransform(21.4,16.4);
		
			this.shape_6 = new cjs.Shape();
			this.shape_6.graphics.f().s("#FF7800").ss(4,1,1).p("AA1iBQANAJAMAMQAqApAAA6QAAAWgHAUQgKAfgZAZQgoApg6AAQg6AAgpgp");
			this.shape_6.setTransform(18.1,17);
		
			this.shape_7 = new cjs.Shape();
			this.shape_7.graphics.f().s("#FF7800").ss(4,1,1).p("AB7hlQAPAdAAAjQAAAXgHATQgKAfgYAZQgpApg5AAQg6AAgpgpQgbgbgKgi");
			this.shape_7.setTransform(16.2,19.8);
		
			this.shape_8 = new cjs.Shape();
			this.shape_8.graphics.f().s("#FF7800").ss(4,1,1).p("ACMgvQAAAXgGAUQgKAegZAYQgpApg6AAQg5AAgpgpQgpgpAAg5QAAgWAGgU");
			this.shape_8.setTransform(16,20.9);
		
			this.shape_9 = new cjs.Shape();
			this.shape_9.graphics.f().s("#FF7800").ss(4,1,1).p("ACCAyQgJAOgMANQgpApg6AAQg5AAgpgpQgpgpAAg5QAAg4Algo");
			this.shape_9.setTransform(15,18.2);
		
			this.shape_10 = new cjs.Shape();
			this.shape_10.graphics.f().s("#FF7800").ss(4,1,1).p("ABqBrQggATgoAAQg5AAgpgpQgpgpAAg5QAAg6ApgpQAGgHAHgFQABAAABgB");
			this.shape_10.setTransform(12.6,17.4);
		
			this.shape_11 = new cjs.Shape();
			this.shape_11.graphics.f().s("#FF7800").ss(4,1,1).p("ABICFQgCAAgCAAQgKAAgKgBQgtgHghghQgpgpAAg5QAAg6ApgpQARgRATgK");
			this.shape_11.setTransform(9.2,16.7);
		
			this.shape_12 = new cjs.Shape();
			this.shape_12.graphics.f().s("#FF7800").ss(4,1,1).p("AAZCEQgVgKgSgSQgpgpAAg6QAAg5ApgpQAegfAogH");
			this.shape_12.setTransform(7.6,15.5);
		
			this.shape_13 = new cjs.Shape();
			this.shape_13.graphics.f().s("#FF7800").ss(4,1,1).p("AgnBsQgWgiAAgrQAAg5ApgpQAigjAwgF");
			this.shape_13.setTransform(8.2,12.9);
		
			this.shape_14 = new cjs.Shape();
			this.shape_14.graphics.f().s("#FF7800").ss(4,1,1).p("AhFBLQAAgFAAgFQAAg6ApgoQAogpA6AA");
			this.shape_14.setTransform(9,9.5);
		
			this.shape_15 = new cjs.Shape();
			this.shape_15.graphics.f().s("#FF7800").ss(4,1,1).p("AhKAyQAJghAagZQAogpA6AAQAJAAAHAB");
			this.shape_15.setTransform(10.1,7);
		
			this.shape_16 = new cjs.Shape();
			this.shape_16.graphics.f().s("#FF7800").ss(4,1,1).p("AhDAaQAEgGAFgFQApgoA6AAQAPAAAMAD");
			this.shape_16.setTransform(12,4.6);
		
			this.shape_17 = new cjs.Shape();
			this.shape_17.graphics.f().s("#FF7800").ss(4,1,1).p("Ag4AJQABgBACgBQABgBAAAAQAdgOAjAAQAZAAAUAH");
			this.shape_17.setTransform(14.8,2.9);
		
			this.shape_18 = new cjs.Shape();
			this.shape_18.graphics.f().s("#FF7800").ss(4,1,1).p("AgsgEQANgCAOAAQAiAAAcAN");
			this.shape_18.setTransform(17.8,2.7);
		
			this.shape_19 = new cjs.Shape();
			this.shape_19.graphics.f().s("#FF7800").ss(4,1,1).p("AgsgNQADAAADAAQAwAAAjAb");
			this.shape_19.setTransform(19.9,3.4);
		
			this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.shape}]}).to({state:[{t:this.shape_1}]},1).to({state:[{t:this.shape_2}]},1).to({state:[{t:this.shape_3}]},1).to({state:[{t:this.shape_4}]},1).to({state:[{t:this.shape_5}]},1).to({state:[{t:this.shape_6}]},1).to({state:[{t:this.shape_7}]},1).to({state:[{t:this.shape_8}]},1).to({state:[{t:this.shape_9}]},1).to({state:[{t:this.shape_10}]},1).to({state:[{t:this.shape_11}]},1).to({state:[{t:this.shape_12}]},1).to({state:[{t:this.shape_13}]},1).to({state:[{t:this.shape_14}]},1).to({state:[{t:this.shape_15}]},1).to({state:[{t:this.shape_16}]},1).to({state:[{t:this.shape_17}]},1).to({state:[{t:this.shape_18}]},1).to({state:[{t:this.shape_19}]},1).wait(1));
		
			// Layer_2
			this.shape_20 = new cjs.Shape();
			this.shape_20.graphics.f("rgba(255,120,0,0)").s().p("AhwByQgvgwAAhCQAAhBAvguQAvgwBBAAQBCAAAvAwQAvAtAABBIAAABIAAAFQgCA/gtAuQgvAuhCAAQhBAAgvgugAhThTQgkAjAAAwQAAAyAkAkQAjAiAwAAQAyAAAjgiQAhgiACgvIAAgFIAAgBQgBgvgigjQgjgkgyAAQgwAAgjAkg");
			this.shape_20.setTransform(16,16);
		
			this.timeline.addTween(cjs.Tween.get(this.shape_20).wait(20));
		
		}).prototype = p = new cjs.MovieClip();
		p.nominalBounds = new cjs.Rectangle(0,0,32,32);
		
		
		// stage content:
		(lib.loading = function(mode,startPosition,loop) {
			this.initialize(mode,startPosition,loop,{});
		
			// Layer_4
			this.instance = new lib.rotation("synched",0);
			this.instance.parent = this;
			this.instance.setTransform(16,16,1,1,0,0,0,16,16);
		
			this.timeline.addTween(cjs.Tween.get(this.instance).to({rotation:88,startPosition:19},19).to({rotation:177},20).to({regY:15.9,rotation:268},20).to({rotation:357,x:16.1},20).wait(1));
		
			// Layer_1
			this.shape = new cjs.Shape();
			this.shape.graphics.f("rgba(45,54,76,0.118)").s().p("AhwByQgvgwAAhCQAAhBAvguQAvgwBBAAQBCAAAvAwQAvAtAABBIAAABIAAAFQgCA/gtAuQgvAuhCAAQhBAAgvgugAhThTQgkAjAAAwQAAAyAkAkQAjAiAwAAQAyAAAjgiQAhgiACgvIAAgFIAAgBQgBgvgigjQgjgkgyAAQgwAAgjAkg");
			this.shape.setTransform(16,16);
		
			this.timeline.addTween(cjs.Tween.get(this.shape).wait(80));
		
		}).prototype = p = new cjs.MovieClip();
		p.nominalBounds = new cjs.Rectangle(16,16,32,32);
		// library properties:
		lib.properties = {
			id: '21F28B28AA40E545AF722E0DE6648C29',
			width: 32,
			height: 32,
			fps: 25,
			color: "#FFFFFF",
			opacity: 1.00,
			manifest: [],
			preloads: []
		};
		
		
		
		// bootstrap callback support:
		
		(lib.Stage = function(canvas) {
			createjs.Stage.call(this, canvas);
		}).prototype = p = new createjs.Stage();
		
		p.setAutoPlay = function(autoPlay) {
			this.tickEnabled = autoPlay;
		}
		p.play = function() { this.tickEnabled = true; this.getChildAt(0).gotoAndPlay(this.getTimelinePosition()) }
		p.stop = function(ms) { if(ms) this.seek(ms); this.tickEnabled = false; }
		p.seek = function(ms) { this.tickEnabled = true; this.getChildAt(0).gotoAndStop(lib.properties.fps * ms / 1000); }
		p.getDuration = function() { return this.getChildAt(0).totalFrames / lib.properties.fps * 1000; }
		
		p.getTimelinePosition = function() { return this.getChildAt(0).currentFrame / lib.properties.fps * 1000; }
		
		an.bootcompsLoaded = an.bootcompsLoaded || [];
		if(!an.bootstrapListeners) {
			an.bootstrapListeners=[];
		}
		
		an.bootstrapCallback=function(fnCallback) {
			an.bootstrapListeners.push(fnCallback);
			if(an.bootcompsLoaded.length > 0) {
				for(var i=0; i<an.bootcompsLoaded.length; ++i) {
					fnCallback(an.bootcompsLoaded[i]);
				}
			}
		};
		
		an.compositions = an.compositions || {};
		an.compositions['21F28B28AA40E545AF722E0DE6648C29'] = {
			getStage: function() { return exportRoot.getStage(); },
			getLibrary: function() { return lib; },
			getSpriteSheet: function() { return ss; },
			getImages: function() { return img; }
		};
		
		an.compositionLoaded = function(id) {
			an.bootcompsLoaded.push(id);
			for(var j=0; j<an.bootstrapListeners.length; j++) {
				an.bootstrapListeners[j](id);
			}
		}
		
		an.getComposition = function(id) {
			return an.compositions[id];
		}

























	var canvas, stage, exportRoot, anim_container, dom_overlay_container, fnStartAnimation;
	function init() {
		canvas = document.getElementById("canvas");
		anim_container = document.getElementById("animation_container");
		dom_overlay_container = document.getElementById("dom_overlay_container");
		var comp=an.getComposition("21F28B28AA40E545AF722E0DE6648C29");
		var lib=comp.getLibrary();
		handleComplete({},comp);
	}
	function handleComplete(evt,comp) {
		//This function is always called, irrespective of the content. You can use the variable "stage" after it is created in token create_stage.
		var lib=comp.getLibrary();
		var ss=comp.getSpriteSheet();
		exportRoot = new lib.loading();
		stage = new lib.Stage(canvas);	
		//Registers the "tick" event listener.
		fnStartAnimation = function() {
			stage.addChild(exportRoot);
			createjs.Ticker.setFPS(lib.properties.fps);
			createjs.Ticker.addEventListener("tick", stage);
		}	    
		//Code to support hidpi screens and responsive scaling.
		function makeResponsive(isResp, respDim, isScale, scaleType) {		
			var lastW, lastH, lastS=1;		
			window.addEventListener('resize', resizeCanvas);		
			resizeCanvas();		
			function resizeCanvas() {			
				var w = lib.properties.width, h = lib.properties.height;			
				var iw = window.innerWidth, ih=window.innerHeight;			
				var pRatio = window.devicePixelRatio || 1, xRatio=iw/w, yRatio=ih/h, sRatio=1;			
				if(isResp) {                
					if((respDim=='width'&&lastW==iw) || (respDim=='height'&&lastH==ih)) {                    
						sRatio = lastS;                
					}				
					else if(!isScale) {					
						if(iw<w || ih<h)						
							sRatio = Math.min(xRatio, yRatio);				
					}				
					else if(scaleType==1) {					
						sRatio = Math.min(xRatio, yRatio);				
					}				
					else if(scaleType==2) {					
						sRatio = Math.max(xRatio, yRatio);				
					}			
				}			
				canvas.width = w*pRatio*sRatio;			
				canvas.height = h*pRatio*sRatio;
				canvas.style.width = dom_overlay_container.style.width = anim_container.style.width =  w*sRatio+'px';				
				canvas.style.height = anim_container.style.height = dom_overlay_container.style.height = h*sRatio+'px';
				stage.scaleX = pRatio*sRatio;			
				stage.scaleY = pRatio*sRatio;			
				lastW = iw; lastH = ih; lastS = sRatio;            
				stage.tickOnUpdate = false;            
				stage.update();            
				stage.tickOnUpdate = true;		
			}
		}
		makeResponsive(false,'both',false,1);	
		an.compositionLoaded(lib.properties.id);
		fnStartAnimation();
	}

	if (canvas) {
		$(document).ready(init);
	}
});
